import { CLIENT_SET, CLIENT_RESET } from "../actionNames";

export function setClient(client) {
  return (dispatch) => {
    dispatch({
      type: CLIENT_SET,
      client,
    });
  };
}

export function resetClient() {
  return (dispatch) =>
    dispatch({
      type: CLIENT_RESET,
    });
}
